/* Speediance for Business page, version 2. Form and interactions. No dependencies.
   All strings come from the JSON island #bmb-i18n rendered by the page snippet. */
(function () {
  'use strict';

  var root = document.querySelector('.bmb[data-bmb-version="2"]');
  if (!root || root.getAttribute('data-bmb-ready')) return;
  root.setAttribute('data-bmb-ready', '1');

  var T0 = Date.now();
  var form = root.querySelector('#bmb-form');
  var card = root.querySelector('#bmb-card');
  var success = root.querySelector('[data-bmb-success]');
  var islandEl = document.getElementById('bmb-i18n');
  if (!form || !card || !islandEl) return;
  var T;
  try { T = JSON.parse(islandEl.textContent); } catch (e) { return; }

  var REGION = root.getAttribute('data-region') || 'EU';
  var LANG = root.getAttribute('data-lang') || 'en';
  var LOCALE = root.getAttribute('data-locale') || LANG;
  var STORE_DEFAULT = (root.getAttribute('data-default-country') || '').toUpperCase();
  var LOC_COUNTRY = (root.getAttribute('data-loc-country') || '').toUpperCase();
  var ENDPOINT = form.getAttribute('data-endpoint');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ISO2 + dial code pairs, same data as the product page enquiry dialog.
  var DIAL_RAW = 'AC247 AD376 AE971 AF93 AG1 AI1 AL355 AM374 AO244 AR54 AS1 AT43 AU61 AW297 AX358 AZ994 BA387 BB1 BD880 BE32 BF226 BG359 BH973 BI257 BJ229 BL590 BM1 BN673 BO591 BQ599 BR55 BS1 BT975 BW267 BY375 BZ501 CA1 CC61 CD243 CF236 CG242 CH41 CI225 CK682 CL56 CM237 CN86 CO57 CR506 CU53 CV238 CW599 CX61 CY357 CZ420 DE49 DJ253 DK45 DM1 DO1 DZ213 EC593 EE372 EG20 EH212 ER291 ES34 ET251 FI358 FJ679 FK500 FM691 FO298 FR33 GA241 GB44 GD1 GE995 GF594 GG44 GH233 GI350 GL299 GM220 GN224 GP590 GQ240 GR30 GT502 GU1 GW245 GY592 HK852 HN504 HR385 HT509 HU36 ID62 IE353 IL972 IM44 IN91 IO246 IQ964 IR98 IS354 IT39 JE44 JM1 JO962 JP81 KE254 KG996 KH855 KI686 KM269 KN1 KP850 KR82 KW965 KY1 KZ7 LA856 LB961 LC1 LI423 LK94 LR231 LS266 LT370 LU352 LV371 LY218 MA212 MC377 MD373 ME382 MF590 MG261 MH692 MK389 ML223 MM95 MN976 MO853 MP1 MQ596 MR222 MS1 MT356 MU230 MV960 MW265 MX52 MY60 MZ258 NA264 NC687 NE227 NF672 NG234 NI505 NL31 NO47 NP977 NR674 NU683 NZ64 OM968 PA507 PE51 PF689 PG675 PH63 PK92 PL48 PM508 PR1 PS970 PT351 PW680 PY595 QA974 RE262 RO40 RS381 RU7 RW250 SA966 SB677 SC248 SD249 SE46 SG65 SH290 SI386 SJ47 SK421 SL232 SM378 SN221 SO252 SR597 SS211 ST239 SV503 SX1 SY963 SZ268 TA290 TC1 TD235 TG228 TH66 TJ992 TK690 TL670 TM993 TN216 TO676 TR90 TT1 TV688 TW886 TZ255 UA380 UG256 US1 UY598 UZ998 VA39 VC1 VE58 VG1 VI1 VN84 VU678 WF681 WS685 XK383 YE967 YT262 ZA27 ZM260 ZW263';
  var DIAL = {};
  var DIAL_ORDER = [];
  DIAL_RAW.split(' ').forEach(function (p) {
    var m = /^([A-Z]{2})(\d+)$/.exec(p);
    if (m) { DIAL[m[1]] = m[2]; DIAL_ORDER.push(m[1]); }
  });
  // Territories that only exist as dial prefixes are not offered as a country.
  var COUNTRY_CODES = DIAL_ORDER.filter(function (c) { return c !== 'AC' && c !== 'TA'; });

  var LOCALE_COUNTRY = { bg: 'BG', da: 'DK', de: 'DE', el: 'GR', et: 'EE', fi: 'FI', fr: 'FR', hr: 'HR', it: 'IT', lb: 'LU', lt: 'LT', lv: 'LV', mt: 'MT', nb: 'NO', nl: 'NL', nn: 'NO', no: 'NO', pt: 'PT', ro: 'RO', sl: 'SI', sv: 'SE', tr: 'TR' };
  function defaultCountry() {
    if (REGION === 'EU') {
      if (!LOC_COUNTRY || LOC_COUNTRY === 'MC') return LOCALE_COUNTRY[String(LOCALE || 'en').split('-')[0].toLowerCase()] || 'IE';
      return LOC_COUNTRY;
    }
    return STORE_DEFAULT || LOC_COUNTRY || { AU: 'AU', NZ: 'NZ', UK: 'GB' }[REGION] || 'IE';
  }

  var BUSINESS_TYPE = {
    hotel: 'Hotel / Hospitality',
    residential: 'Luxury Residential (Apartments, Villas)',
    studio: 'Personal Training Studio',
    gym: 'Boutique Gym / Microgym',
    corporate: 'Corporate Wellness / Office Gym',
    clinic: 'Physiotherapy / Rehab',
    sports: 'Sports Team / Club',
    partner: 'Reseller / Distributor',
    other: 'Other'
  };

  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function fld(name) { return form.elements[name]; }
  function checked(name) { return form.querySelector('input[name="' + name + '"]:checked'); }
  function tr(key, vars) {
    var s = T[key] == null ? '' : String(T[key]);
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  // The store themes set html { scroll-behavior: smooth }, so behavior 'auto' still animates.
  // Under reduced motion the jump is made instant by switching that off for the one call.
  function jumpTo(el) {
    if (!el) return;
    if (!reduceMotion) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    var h = document.documentElement, prev = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    el.scrollIntoView({ block: 'start' });
    h.style.scrollBehavior = prev;
  }

  /* ---------- Attribution ---------- */
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];
  var attr = {};
  var referrer = '';
  (function () {
    var fromUrl = {};
    try {
      var sp = new URLSearchParams(window.location.search);
      ATTR_KEYS.forEach(function (k) { var v = sp.get(k); if (v) fromUrl[k] = v.slice(0, 300); });
    } catch (e) { /* ignore */ }
    var stored = null;
    try { stored = JSON.parse(window.sessionStorage.getItem('bmb_attr') || 'null'); } catch (e) { stored = null; }
    if (stored && typeof stored === 'object') {
      referrer = String(stored.r || '');
      attr = Object.keys(fromUrl).length ? fromUrl : (stored.p || {});
    } else {
      referrer = String(document.referrer || '').slice(0, 500);
      attr = fromUrl;
      try { window.sessionStorage.setItem('bmb_attr', JSON.stringify({ p: fromUrl, r: referrer })); } catch (e) { /* ignore */ }
    }
  })();

  /* ---------- Country and dial selects ---------- */
  var countrySel = fld('country_code');
  var dialSel = fld('phone_dial');
  var phoneInp = fld('phone');
  var dialTouched = false;

  function regionNames(loc) {
    try { return new Intl.DisplayNames([loc, loc === 'lb' ? 'de' : 'en'], { type: 'region' }); } catch (e) { return null; }
  }
  var namesLocal = regionNames(LANG);
  var SORT_LANG = LANG === 'lb' ? 'de' : LANG;
  var namesEn = regionNames('en');
  function nameOf(code, names) {
    try { return (names && names.of(code)) || code; } catch (e) { return code; }
  }

  function buildSelects() {
    var def = defaultCountry();
    var list = COUNTRY_CODES.map(function (c) { return { c: c, n: nameOf(c, namesLocal) }; });
    list.sort(function (a, b) { return a.n.localeCompare(b.n, SORT_LANG); });
    if (COUNTRY_CODES.indexOf(def) < 0) def = '';
    var frag = document.createDocumentFragment();
    if (!def) {
      var ph = new Option(countrySel.getAttribute('data-placeholder') || '', '');
      ph.disabled = true; ph.selected = true;
      frag.appendChild(ph);
    }
    if (def) frag.appendChild(new Option(nameOf(def, namesLocal), def));
    list.forEach(function (x) { if (x.c !== def) frag.appendChild(new Option(x.n, x.c)); });
    countrySel.appendChild(frag);
    if (def) countrySel.value = def;

    var dlist = DIAL_ORDER.map(function (c) { return { c: c, n: nameOf(c, namesLocal) }; });
    dlist.sort(function (a, b) { return a.n.localeCompare(b.n, SORT_LANG); });
    var dfrag = document.createDocumentFragment();
    dlist.forEach(function (x) { dfrag.appendChild(new Option(x.n + ' (+' + DIAL[x.c] + ')', x.c)); });
    dialSel.appendChild(dfrag);
    if (def && DIAL[def]) dialSel.value = def;
  }
  buildSelects();

  countrySel.addEventListener('change', function () {
    if (!dialTouched && DIAL[countrySel.value]) dialSel.value = countrySel.value;
  });
  dialSel.addEventListener('change', function () {
    dialTouched = true;
    if (phoneInp.getAttribute('aria-invalid') === 'true') { phoneInp.removeAttribute('aria-invalid'); resolved('phone'); }
  });

  /* ---------- Phone ---------- */
  // Countries where the leading 0 of a national number belongs to the international number (+39 06 ...),
  // so it is kept. Everywhere else one leading 0 is a trunk prefix and is dropped.
  var KEEP_TRUNK = { IT: 1, SM: 1, VA: 1, CI: 1, CG: 1, GA: 1 };
  // National prefixes other than a single 0: Hungary 06, Lithuania 8 (legacy). Same rule as the backend.
  var TRUNK_ISO = { HU: /^06(?=\d{8,9}$)/, LT: /^8(?=\d{8}$)/ };
  var TRUNK_CC = { '36': TRUNK_ISO.HU, '370': TRUNK_ISO.LT };
  var CC_SET = {};
  var KEEP_CC = {};
  DIAL_ORDER.forEach(function (c) {
    CC_SET[DIAL[c]] = 1;
    if (KEEP_TRUNK[c]) KEEP_CC[DIAL[c]] = 1;
  });
  // Spaces, dots, dashes, slashes, brackets and the Unicode hyphens U+2010 to U+2015.
  var PHONE_SEP = /[\s.\-\/()\u2010-\u2015]/g;
  function typedCc(s) {
    for (var n = 3; n >= 1; n--) { var c = s.slice(1, 1 + n); if (CC_SET[c]) return c; }
    return '';
  }
  function normalisePhone(raw, iso) {
    var src = String(raw || '');
    // A trunk zero written in brackets after the country code, as in +44 (0)7700 900123, is not part of the number.
    if (/^\s*(\+|00)\s*\d{1,4}[\s.\-\/\u2010-\u2015]*\(0\)/.test(src)) src = src.replace(/\(0\)/, '');
    var s = src.replace(PHONE_SEP, '');
    if (s.slice(0, 2) === '00') s = '+' + s.slice(2);
    if (s.charAt(0) !== '+') {
      if (TRUNK_ISO[iso] && TRUNK_ISO[iso].test(s)) return '+' + (DIAL[iso] || '') + s.replace(TRUNK_ISO[iso], '');
      return '+' + (DIAL[iso] || '') + (KEEP_TRUNK[iso] ? s : s.replace(/^0/, ''));
    }
    // A trunk zero typed straight after the country code (+44 0 7700 900123, +49 (030) 1234567) is dropped too.
    var cc = typedCc(s);
    var rest = cc ? s.slice(1 + cc.length) : '';
    if (cc && TRUNK_CC[cc] && TRUNK_CC[cc].test(rest)) return '+' + cc + rest.replace(TRUNK_CC[cc], '');
    if (cc && !KEEP_CC[cc] && s.charAt(1 + cc.length) === '0') s = '+' + cc + s.slice(cc.length + 2);
    return s;
  }
  function phoneValid(e164) { return /^\+[1-9]\d{6,14}$/.test(e164); }

  /* ---------- Steps ---------- */
  var panes = qa('[data-bmb-step]');
  var bar = qa('.bmb-progress__bar span');
  var progressLabel = q('[data-bmb-progress-label]');
  var current = 1;

  function setStep(n, focus) {
    current = n;
    panes.forEach(function (p) { p.hidden = Number(p.getAttribute('data-bmb-step')) !== n; });
    bar.forEach(function (s, i) { s.classList.toggle('is-on', i < n); });
    // Leave the live region alone when the text is unchanged, so init does not announce "Step 1 of 3".
    var label = tr('step_label', { n: n, total: 3 });
    if (progressLabel.textContent.replace(/\u00a0/g, ' ') !== label.replace(/\u00a0/g, ' ')) progressLabel.textContent = label;
    if (focus) {
      var h = q('[data-bmb-step="' + n + '"] .bmb-step__title');
      if (h) h.focus({ preventScroll: true });
      var top = card.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) jumpTo(card);
    }
  }

  function updateNextState() {
    var btn = q('[data-bmb-step="1"] [data-bmb-next]');
    if (!btn) return;
    if (checked('segment')) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
  }
  function updateUnitsLabel() {
    var seg = checked('segment');
    var lab = q('[data-bmb-units-label]');
    if (lab) lab.textContent = seg && seg.value === 'partner' ? tr('units_label_partner') : tr('units_label');
  }

  /* ---------- Errors ---------- */
  function fieldFocusTarget(name) {
    if (name === 'segment' || name === 'units' || name === 'timeline') return form.querySelector('input[name="' + name + '"]');
    return fld(name);
  }
  // Radio groups carry aria-invalid on their group element, since a RadioNodeList is not an element.
  function groupOf(name) {
    if (name !== 'segment' && name !== 'units' && name !== 'timeline') return null;
    var i = form.querySelector('input[name="' + name + '"]');
    return i ? i.closest('[role="radiogroup"]') : null;
  }
  function clearErrors(pane) {
    qa('.bmb-field-error', pane).forEach(function (e) { e.textContent = ''; });
    qa('[aria-invalid="true"]', pane).forEach(function (e) { e.removeAttribute('aria-invalid'); });
    var s = q('[data-bmb-summary]', pane);
    if (s) { s.hidden = true; s.textContent = ''; }
    var fe = q('[data-bmb-form-error]', form);
    if (fe) { fe.hidden = true; fe.textContent = ''; }
  }
  function setError(name, message) {
    var e = q('[data-bmb-error="' + name + '"]', form);
    if (e) {
      e.textContent = '';
      var pre = document.createElement('span');
      pre.className = 'bmb-sr';
      pre.textContent = tr('error_prefix') + ' ';
      e.appendChild(pre);
      e.appendChild(document.createTextNode(message));
    }
    var f = fld(name);
    if (f && f.nodeType === 1) f.setAttribute('aria-invalid', 'true');
    var g = groupOf(name);
    if (g) g.setAttribute('aria-invalid', 'true');
  }
  function showSummary(pane, errs) {
    var s = q('[data-bmb-summary]', pane);
    if (!s) return;
    s.textContent = '';
    var p = document.createElement('p');
    p.textContent = tr('err_summary');
    var ul = document.createElement('ul');
    errs.forEach(function (er) {
      var li = document.createElement('li');
      li.setAttribute('data-name', er.name);
      var a = document.createElement('a');
      a.href = '#';
      var lg = (er.name === 'units' || er.name === 'timeline') ? q('[data-bmb-error="' + er.name + '"]', form).closest('fieldset').querySelector('legend') : null;
      a.textContent = lg ? lg.firstChild.textContent.trim() + ' ' + er.message : er.message;
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        var t = fieldFocusTarget(er.name);
        if (t) t.focus();
      });
      li.appendChild(a);
      ul.appendChild(li);
    });
    s.appendChild(p);
    s.appendChild(ul);
    s.hidden = false;
    s.focus({ preventScroll: false });
  }

  function validate(step) {
    var pane = q('[data-bmb-step="' + step + '"]');
    clearErrors(pane);
    var errs = [];
    function need(name, ok, msg) { if (!ok) errs.push({ name: name, message: msg }); }
    if (step === 1) {
      need('segment', !!checked('segment'), tr('err_choose'));
    } else if (step === 2) {
      need('units', !!checked('units'), tr('err_choose'));
      need('timeline', !!checked('timeline'), tr('err_choose'));
    } else {
      need('name', fld('name').value.trim().length > 1, tr('err_name'));
      need('company', fld('company').value.trim().length > 0, tr('err_company'));
      need('email', /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(fld('email').value.trim()), tr('err_email'));
      need('country_code', !!countrySel.value, tr('err_country'));
      need('phone', phoneValid(normalisePhone(phoneInp.value, dialSel.value)), tr('err_phone'));
    }
    if (errs.length) {
      errs.forEach(function (er) { setError(er.name, er.message); });
      showSummary(pane, errs);
      return false;
    }
    return true;
  }

  /* ---------- Navigation ---------- */
  qa('[data-bmb-next]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (validate(current)) setStep(current + 1, true);
    });
  });
  qa('[data-bmb-back]').forEach(function (b) {
    b.addEventListener('click', function () { if (current > 1) setStep(current - 1, true); });
  });

  qa('input[name="segment"]').forEach(function (r) {
    r.addEventListener('change', function (ev) {
      // A person changing the segment leaves the package they came in with. The tile and package
      // buttons check the radio with a scripted event (not trusted) and set the package themselves.
      if (ev.isTrusted) fld('package_interest').value = '';
      updateNextState();
      updateUnitsLabel();
      resolved('segment');
    });
  });
  ['units', 'timeline'].forEach(function (n) {
    qa('input[name="' + n + '"]').forEach(function (r) {
      r.addEventListener('change', function () { resolved(n); });
    });
  });

  // "Not sure yet" and the specific machines exclude each other.
  var unsure = q('input[data-bmb-unsure]');
  qa('input[name="products"]').forEach(function (c) {
    c.addEventListener('change', function () {
      if (!c.checked) return;
      qa('input[name="products"]').forEach(function (o) {
        if (o === c) return;
        if (c === unsure || o === unsure) o.checked = false;
      });
    });
  });

  // Once a flagged field is edited, drop its error and its line in the summary.
  function resolved(name) {
    var e = q('[data-bmb-error="' + name + '"]');
    if (e) e.textContent = '';
    var g = groupOf(name);
    if (g) g.removeAttribute('aria-invalid');
    var pane = q('[data-bmb-step="' + current + '"]');
    var s = pane && q('[data-bmb-summary]', pane);
    if (!s || s.hidden) return;
    var li = s.querySelector('li[data-name="' + name + '"]');
    if (li) li.parentNode.removeChild(li);
    if (!s.querySelector('li')) { s.hidden = true; s.textContent = ''; }
  }
  qa('.bmb-input').forEach(function (i) {
    i.addEventListener('input', function () {
      if (i.getAttribute('aria-invalid') === 'true') { i.removeAttribute('aria-invalid'); resolved(i.name); }
    });
  });

  /* ---------- Segment, package and partner buttons ---------- */
  qa('[data-bmb-segment]').forEach(function (b) {
    b.addEventListener('click', function () {
      // After a sent brief the form is gone: take the person to the confirmation instead of a hidden form.
      if (!success.hidden) {
        jumpTo(document.getElementById('bmb-proposal'));
        var st = q('[data-bmb-success-title]');
        if (st) st.focus({ preventScroll: true });
        return;
      }
      var key = b.getAttribute('data-bmb-segment');
      var radio = form.querySelector('input[name="segment"][value="' + key + '"]');
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      fld('package_interest').value = b.getAttribute('data-bmb-package') || '';
      qa('[data-bmb-step]').forEach(function (p) { clearErrors(p); });
      setStep(1, false);
      jumpTo(document.getElementById('bmb-proposal'));
      var h = q('#bmb-s1-title');
      if (h) h.focus({ preventScroll: true });
    });
  });

  /* ---------- In-page links under reduced motion ---------- */
  // The hero and success buttons are plain #anchors, which the theme's smooth scrolling would animate.
  if (reduceMotion) {
    qa('a[href^="#bmb-"]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        if (ev.defaultPrevented || ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target) return;
        ev.preventDefault();
        jumpTo(target);
        // Preventing the default drops the browser's focus navigation start point, so set it here.
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  /* ---------- Submit ---------- */
  function buildPayload() {
    var seg = checked('segment').value;
    var iso = countrySel.value;
    var prods = qa('input[name="products"]:checked').map(function (c) { return c.value; }).join(', ');
    var p = {
      name: fld('name').value.trim(),
      company: fld('company').value.trim(),
      email: fld('email').value.trim(),
      phone: normalisePhone(phoneInp.value, dialSel.value),
      phone_country: dialSel.value,
      title: fld('title').value.trim(),
      country_code: iso,
      location: nameOf(iso, namesEn),
      lead_track: seg === 'partner' ? 'partner' : 'project',
      segment: seg,
      business_type: BUSINESS_TYPE[seg] || 'Other',
      unit_requirement: checked('units').value,
      project_timeline: checked('timeline').value,
      products_of_interest: prods,
      package_interest: fld('package_interest').value || '',
      customer_message: fld('customer_message').value.trim(),
      region: REGION,
      storefront_url: window.location.href.split('#')[0].split('?')[0],
      page_locale: LOCALE,
      referrer: referrer,
      form_version: 'b2b-v2',
      form_age_ms: Date.now() - T0,
      hp_url: fld('hp_url').value
    };
    ATTR_KEYS.forEach(function (k) { p[k] = attr[k] || ''; });
    return p;
  }

  function post(payload) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'omit',
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) { clearTimeout(timer); return res; }, function (err) { clearTimeout(timer); throw err; });
  }
  function postWithRetry(payload) {
    return post(payload).then(function (res) {
      if (res.status >= 500) return wait(1500).then(function () { return post(payload); });
      return res;
    }, function (err) {
      // A timeout is not a dropped connection: the first request may already be saved, so it is not sent again.
      if (err && err.name === 'AbortError') throw err;
      return wait(1500).then(function () { return post(payload); });
    });
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function showFormError(message) {
    var box = q('[data-bmb-form-error]', form);
    if (!box) return;
    box.textContent = '';
    var email = root.querySelector('.bmb-mail a');
    var addr = email ? email.textContent : '';
    var idx = addr ? message.indexOf(addr) : -1;
    if (idx >= 0) {
      box.appendChild(document.createTextNode(message.slice(0, idx)));
      var a = document.createElement('a');
      a.href = 'mailto:' + addr;
      a.textContent = addr;
      box.appendChild(a);
      box.appendChild(document.createTextNode(message.slice(idx + addr.length)));
    } else {
      box.textContent = message;
    }
    box.hidden = false;
  }

  function showSuccess(payload) {
    var first = payload.name.split(/\s+/)[0];
    var titleEl = q('[data-bmb-success-title]', success);
    titleEl.textContent = tr('success_title', { name: first });
    var dl = q('[data-bmb-success-summary]', success);
    dl.textContent = '';
    function row(dt, dd) {
      var d = document.createElement('div');
      var a = document.createElement('dt'); a.textContent = dt;
      var b = document.createElement('dd'); b.textContent = dd;
      d.appendChild(a); d.appendChild(b); dl.appendChild(d);
    }
    function chipText(name) {
      var i = checked(name);
      var s = i && i.nextElementSibling;
      return s ? s.textContent.trim() : '';
    }
    var segEl = checked('segment');
    row(tr('s1_title'), chipText('segment'));
    row(segEl && segEl.value === 'partner' ? tr('units_label_partner') : tr('units_label'), chipText('units'));
    row(tr('timeline_label'), chipText('timeline'));
    form.hidden = true;
    success.hidden = false;
    root.classList.add('bmb-sent');
    titleEl.focus({ preventScroll: true });
    var top = card.getBoundingClientRect().top;
    if (top < 0) jumpTo(card);
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'b2b_enquiry_submitted', segment: payload.segment, units: payload.unit_requirement, region: REGION });
      }
    } catch (e) { /* ignore */ }
  }

  var FIELD_MAP = { name: 'name', company: 'company', email: 'email', phone: 'phone', country_code: 'country_code', location: 'country_code' };
  var FIELD_MSG = { name: 'err_name', company: 'err_company', email: 'err_email', phone: 'err_phone', country_code: 'err_country', location: 'err_country' };

  var submitBtn = q('[data-bmb-submit]', form);
  var submitLabel = submitBtn ? submitBtn.textContent : '';
  var sending = false;

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (current < 3) { if (validate(current)) setStep(current + 1, true); return; }
    if (sending) return;
    if (!validate(3)) return;
    var payload = buildPayload();
    sending = true;
    submitBtn.disabled = true;
    submitBtn.textContent = submitBtn.getAttribute('data-sending') || tr('sending');
    postWithRetry(payload).then(function (res) {
      if (res.status >= 200 && res.status < 300) { showSuccess(payload); return; }
      if (res.status === 429) { showFormError(tr('err_rate')); return; }
      if (res.status === 400) {
        return res.json().then(function (b) { return b || {}; }, function () { return {}; }).then(function (b) {
          var f = FIELD_MAP[b.field];
          if (!f) { showFormError(tr('err_network')); return; }
          var pane = q('[data-bmb-step="3"]');
          clearErrors(pane);
          setStep(3, false);
          var msg = tr(FIELD_MSG[b.field]);
          setError(f, msg);
          showSummary(pane, [{ name: f, message: msg }]);
        });
      }
      showFormError(tr('err_network'));
    }, function () {
      showFormError(tr('err_network'));
    }).catch(function () {
      showFormError(tr('err_network'));
    }).then(function () {
      sending = false;
      if (!success.hidden) return;
      submitBtn.disabled = false;
      submitBtn.textContent = submitLabel;
      // Disabling the button while it held focus dropped focus to <body>; hand it back.
      if (!form.contains(document.activeElement)) submitBtn.focus({ preventScroll: true });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var items = qa('[data-bmb-reveal]');
    root.classList.add('bmb-reveal-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky header overlap ---------- */
  // Some store themes lay the sticky header over the top of the page (negative bottom margin).
  // Measure that overlap so the hero clears it at whatever height the theme uses at this width.
  function measureHeader() {
    var hdr = document.querySelector('[id^="shopify-section-"][id$="__header"]') || document.querySelector('.section-header');
    if (!hdr) return;
    var mb = parseFloat(window.getComputedStyle(hdr).marginBottom) || 0;
    root.style.setProperty('--bmb-hdr', (mb < 0 ? Math.min(-mb, 160) : 0) + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader);

  /* ---------- Init ---------- */
  updateNextState();
  updateUnitsLabel();
  setStep(1, false);
  if (submitBtn) submitBtn.disabled = false;
  // Only now: until init has finished, the no-JS notice stays visible instead of a dead form.
  root.classList.add('bmb-js');
})();
